import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Dropdown } from 'bootstrap-italia';
import {
  KeycloakEvent,
  KeycloakEventType,
  KeycloakService,
} from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { from } from 'rxjs';
import { UserRoles } from 'src/app/auth/auth.model';
import { RoleService } from '@shared/services/role/role.service';
import { Router } from '@angular/router';
import { getServiziRoute } from '../../app.routes';

@Component({
  selector: 'app-user-bar',
  templateUrl: './user-bar.component.html',
  styleUrls: ['./user-bar.component.scss'],
})
export class UserBarComponent implements OnInit {
  language: string = 'it';
  nomeUtente: string = 'Luigi Verdi';
  isAuthenticated: boolean = false;

  userRoles = UserRoles;
  activeDropdown: Dropdown | undefined;
  activelangDropdownRef: HTMLAnchorElement | undefined;

  @ViewChild('menuUtente') menuUtente!: ElementRef;
  @ViewChild('menuLingua') menuLingua!: ElementRef;
  @ViewChild('lang_dropdown') langDropdown!: ElementRef;
  @ViewChild('profile_dropdown') profileDropdown!: ElementRef;

  roleCardTitle: string = '';
  ruoloAttuale: string = '';
  langOpened: boolean = false;
  profileOpened: boolean = false;

  constructor(
    private translateSrv: TranslateService,
    private keycloakSrv: KeycloakService,
    private roleService: RoleService,
    private router: Router
  ) {}

  ngOnInit() {
    this.language = this.translateSrv.currentLang;
    this.setUserAuth();
    this.setUserNameSurname();
    this.keycloakSrv.keycloakEvents$.subscribe((event: KeycloakEvent) => {
      if (
        event.type == KeycloakEventType.OnAuthLogout ||
        event.type == KeycloakEventType.OnTokenExpired ||
        event.type == KeycloakEventType.OnAuthSuccess
      ) {
        this.setUserAuth();
      }
      if (event.type == KeycloakEventType.OnAuthSuccess) {
        this.setUserNameSurname();
      }
    });
    this.setRoleCardTitle();
  }

  onAnchorKeyUp(
    event: KeyboardEvent,
    dropdown: string,
    menuName: string
  ): void {
    if (event.key === 'ArrowUp') {
      this.moveFocus(-1, menuName);
      event.preventDefault();
    } else if (event.key === 'ArrowDown') {
      this.moveFocus(1, menuName);
      event.preventDefault();
    } else if (event.code === 'Space') {
      event.preventDefault();
      if (dropdown === 'lang') {
        this.toggleDropdownLang();
      } else if (dropdown === 'profile') {
        this.toggleDropdownProfile();
      }
    }
  }

  moveFocus(step: number, menuName: string): void {
    let menuItems: any[] = [];
    if (menuName === 'lingua') {
      menuItems = this.menuLingua.nativeElement.querySelectorAll('a');
    } else if (menuName === 'utente') {
      menuItems = this.menuUtente.nativeElement.querySelectorAll('a');
    }

    if (menuItems.length === 0) {
      return;
    }

    const currentFocus: HTMLElement = document.activeElement as HTMLElement;

    if (!currentFocus) {
      return;
    }

    let currentIndex: number = Array.from(menuItems).indexOf(currentFocus);
    let nextIndex: number = currentIndex + step;

    if (nextIndex >= menuItems.length) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = menuItems.length - 1;
    }

    if (currentIndex !== nextIndex) {
      menuItems[nextIndex].focus();
    }
  }

  setUserNameSurname() {
    from(this.keycloakSrv.loadUserProfile()).subscribe(
      (profile: KeycloakProfile) => {
        if (profile) {
          this.nomeUtente = profile.firstName! + ' ' + profile.lastName;
        }
      }
    );
  }

  toggleDropdownLang(): void {
    this.activeDropdown = new Dropdown(this.langDropdown.nativeElement);
    this.activelangDropdownRef = this.langDropdown
      .nativeElement as HTMLAnchorElement;
    this.activeDropdown.toggle();
    if (this.langOpened) {
      this.langOpened = false;
    } else {
      this.langOpened = true;
    }
  }

  toggleDropdownProfile(): void {
    this.activeDropdown = new Dropdown(this.profileDropdown.nativeElement);
    this.activelangDropdownRef = this.profileDropdown
      .nativeElement as HTMLAnchorElement;
    this.activeDropdown.toggle();
    if (this.profileOpened) {
      this.profileOpened = false;
    } else {
      this.profileOpened = true;
    }
  }

  setRoleCardTitle() {
    this.roleService.ruoloAttuale.subscribe((ruoloAttuale) => {
      this.ruoloAttuale = ruoloAttuale;
      this.roleCardTitle = this.getRoleString(ruoloAttuale);
    });
  }

  getRoleString(ruolo: string): string {
    switch (ruolo) {
      case this.userRoles.CPI:
        return 'ROLE_CPI';
      case this.userRoles.ENTE:
        return 'ROLE_ENTE';
      case this.userRoles.REGIONE:
        return 'ROLE_REGIONE';
      case this.userRoles.DOCENTE:
        return 'ROLE_DOCENTE';
      case this.userRoles.CITTADINO:
        return 'ROLE_CITTADINO';
      case this.userRoles.PRESIDENTE:
        return 'PRESIDENTE';
      case this.userRoles.TUTOR:
        return 'ROLE_TUTOR';
      default:
        return 'ROLE_UNKNOWN';
    }
  }

  changeRole(selectedRole: string) {
    this.router.navigate([getServiziRoute()]).then((value) => {
      if (value || value === null) {
        this.roleService.setRuoloAttuale(selectedRole);
      }
    });
  }

  get roleListExeptCurrent(): string[] {
    return this.roleService
      .getListaRuoliUtente()
      .filter((role: string) => role !== this.ruoloAttuale);
  }

  setUserAuth() {
    from(this.keycloakSrv.isLoggedIn()).subscribe((auth) => {
      this.isAuthenticated = auth;
    });
  }

  changeLanguage(lang: string) {
    this.translateSrv.use(lang);
    this.language = lang;
  }

  logout() {
    this.keycloakSrv.logout(window.location.origin + '/servizi');
  }
}
